import React from "react";
import EditorSessionTableRow from "../../dashboard/program-builder/components/EditorSessionTableRow";
import DayExerciseLineItem from "./components/DayExerciseLineItem";

const ExerciseFrame = ({
  activeExercises,
  openQuickEdit,
  editCycle,
  program,
  session,
  fromMetric,
  activeUser,
  handleDuplicate,
  openQuickEditMode,
  handleQuickEditChange,
  loadInputs,
  intensityInputs,
  query,
  saveQuickEdit,
  exercises,
  closeQuickEditMode,
}) => {
  return activeExercises ? (
    <section className={`exercises-frame ${openQuickEdit && "quick-edit"}`}>
      <form id="quick-edit">
        <ul className="exercises-list">
          {activeExercises.map((exercise, i) => (
            <EditorSessionTableRow
              key={`${exercise._id}tablerow`}
              exercises={activeExercises}
              exercise={exercise._id}
              exerciseOrder={i}
              cycle={editCycle}
              program={program}
              programOrder={program ? program.order : {}}
              session={session}
              fromMetric={fromMetric}
              activeUser={activeUser}
              handleDuplicate={handleDuplicate}
              openQuickEditMode={openQuickEditMode}
              handleQuickEditChange={handleQuickEditChange}
              loadInputs={loadInputs}
              intensityInputs={intensityInputs}
              isQuickEditOpen={openQuickEdit}
              LineItemComponent={DayExerciseLineItem}
              stateExercise={exercises.find((ex) => ex._id === exercise._id)}
            />
          ))}
        </ul>

        <footer>
          <button
            onClick={saveQuickEdit}
            data-button-type="primary"
            disabled={!exercises.length && !query.edit}
          >
            Save
          </button>
          <button
            onClick={closeQuickEditMode}
            data-button-type="secondary"
            className="!text-[--danger]"
          >
            Discard
          </button>
        </footer>
      </form>
    </section>
  ) : (
    <h2>
      This workout does not exist, go back to the program editor to add it in.
    </h2>
  );
};

export default ExerciseFrame;
